import React from "react";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

export default class FullscreenImageBox extends React.Component {
  render() {
    return (
      <Grid item xs={12} md={4} direction="column">
        <Grid container className="custom-grid-container">
          <Grid item xs={12} md={12}>
            {this.props.getBlogImageComponent()}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
FullscreenImageBox.propTypes = {
  getBlogImageComponent: PropTypes.func.isRequired,
};
